import React from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import { COLORS } from "../../constants";
import MerchContent from "./MerchContent";

const DesktopMerchandising = ({
  categories,
  selectedCategory,
  handleCategorySelect,
}) => (
  <Grid
    container
    spacing={3}
    sx={{ flexDirection: { xs: "column", md: "row" }, my: 1 }}
  >
    {/* Left Sidebar - Category Buttons */}
    <Grid item xs={12} md={3.8}>
      <Box
        sx={{
          borderRadius: "2px",
          height: "100%",
        }}
      >
        <Typography
          sx={{
            fontSize: "var(--font-size-xxl)",
            fontWeight: 500,
            lineHeight: "var(--spacing-xxl)",
            color: COLORS.darkText,
          }}
        >
          Argus Motoring Merchandising
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: COLORS.lightText,
            mb: 2,
            lineHeight: 1.8,
            mt: 3,
            fontSize: "var(--font-size-s)",
          }}
        >
          We’re excited to announce the arrival of our brand-new BETA range.
          Your one-stop solution for quality reliable general spares.
        </Typography>

        <Box
          sx={{
            display: "inline-block",
            flexDirection: "column",
            gap: 1,
            mt: 4,
          }}
        >
          {categories.map((category) => (
            <Button
              key={category.title}
              onClick={() => handleCategorySelect(category.title)}
              sx={{
                px: 3,
                py: 1.2,
                mr: 1,
                my: 1,
                backgroundColor:
                  selectedCategory === category.title
                    ? COLORS.themeRed
                    : COLORS.white,
                border: `1px solid ${COLORS.border}`,
                borderRadius: "99px",
                fontSize: "var(--font-size-xs)",
                color:
                  selectedCategory === category.title
                    ? COLORS.white
                    : COLORS.lightText,
                textTransform: "none",
                justifyContent: "flex-start",
                "&:hover": {
                  backgroundColor:
                    selectedCategory === category.title
                      ? COLORS.themeRed
                      : COLORS.border,
                },
              }}
            >
              {category.title}
            </Button>
          ))}
        </Box>
      </Box>
    </Grid>

    {/* Right Side - Content Area */}
    <Grid item xs={12} md={8.2}>
      <MerchContent selectedCategory={selectedCategory} />
    </Grid>
  </Grid>
);

export default DesktopMerchandising;
